"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Schemas = require('./EtpSchemas.js');
var Energistics;
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ArrayOfBoolean = (function () {
            function ArrayOfBoolean() {
                this.values = [];
            }
            return ArrayOfBoolean;
        }());
        ArrayOfBoolean._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes","name":"ArrayOfBoolean","fields":[{"name":"values","type":{"type":"array","items":"boolean"}}],"fullName":"Energistics.Datatypes.ArrayOfBoolean","depends":[]}');
        Datatypes.ArrayOfBoolean = ArrayOfBoolean;
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ArrayOfDouble = (function () {
            function ArrayOfDouble() {
                this.values = [];
            }
            return ArrayOfDouble;
        }());
        ArrayOfDouble._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes","name":"ArrayOfDouble","fields":[{"name":"values","type":{"type":"array","items":"double"}}],"fullName":"Energistics.Datatypes.ArrayOfDouble","depends":[]}');
        Datatypes.ArrayOfDouble = ArrayOfDouble;
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ArrayOfFloat = (function () {
            function ArrayOfFloat() {
                this.values = [];
            }
            return ArrayOfFloat;
        }());
        ArrayOfFloat._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes","name":"ArrayOfFloat","fields":[{"name":"values","type":{"type":"array","items":"float"}}],"fullName":"Energistics.Datatypes.ArrayOfFloat","depends":[]}');
        Datatypes.ArrayOfFloat = ArrayOfFloat;
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ArrayOfLong = (function () {
            function ArrayOfLong() {
                this.values = [];
            }
            return ArrayOfLong;
        }());
        ArrayOfLong._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes","name":"ArrayOfLong","fields":[{"name":"values","type":{"type":"array","items":"long"}}],"fullName":"Energistics.Datatypes.ArrayOfLong","depends":[]}');
        Datatypes.ArrayOfLong = ArrayOfLong;
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ArrayOfInt = (function () {
            function ArrayOfInt() {
                this.values = [];
            }
            return ArrayOfInt;
        }());
        ArrayOfInt._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes","name":"ArrayOfInt","fields":[{"name":"values","type":{"type":"array","items":"int"}}],"fullName":"Energistics.Datatypes.ArrayOfInt","depends":[]}');
        Datatypes.ArrayOfInt = ArrayOfInt;
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var AnyArray = (function () {
            function AnyArray() {
            }
            return AnyArray;
        }());
        AnyArray._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes","name":"AnyArray","fields":[{"name":"item","type":["null","Energistics.Datatypes.ArrayOfBoolean","bytes","Energistics.Datatypes.ArrayOfInt","Energistics.Datatypes.ArrayOfLong","Energistics.Datatypes.ArrayOfFloat","Energistics.Datatypes.ArrayOfDouble"]}],"fullName":"Energistics.Datatypes.AnyArray","depends":["Energistics.Datatypes.ArrayOfBoolean","Energistics.Datatypes.ArrayOfInt","Energistics.Datatypes.ArrayOfLong","Energistics.Datatypes.ArrayOfFloat","Energistics.Datatypes.ArrayOfDouble"]}');
        Datatypes.AnyArray = AnyArray;
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var Contact = (function () {
            function Contact() {
            }
            return Contact;
        }());
        Contact._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes","name":"Contact","fields":[{"name":"organizationName","type":["null","string"]},{"name":"contactName","type":["null","string"]},{"name":"contactPhone","type":["null","string"]},{"name":"contactEmail","type":["null","string"]}],"fullName":"Energistics.Datatypes.Contact","depends":[]}');
        Datatypes.Contact = Contact;
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var DataValue = (function () {
            function DataValue() {
            }
            return DataValue;
        }());
        DataValue._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes","name":"DataValue","fields":[{"name":"item","type":["null","double","float","int","long","string","Energistics.Datatypes.ArrayOfDouble","boolean","bytes"]}],"fullName":"Energistics.Datatypes.DataValue","depends":["Energistics.Datatypes.ArrayOfDouble"]}');
        Datatypes.DataValue = DataValue;
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var DataAttribute = (function () {
            function DataAttribute() {
                this.attributeId = 0;
                this.attributeValue = new Energistics.Datatypes.DataValue();
            }
            return DataAttribute;
        }());
        DataAttribute._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes","name":"DataAttribute","fields":[{"name":"attributeId","type":"int"},{"name":"attributeValue","type":"Energistics.Datatypes.DataValue"}],"fullName":"Energistics.Datatypes.DataAttribute","depends":["Energistics.Datatypes.DataValue"]}');
        Datatypes.DataAttribute = DataAttribute;
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var MessageHeader = (function () {
            function MessageHeader() {
                this.protocol = 0;
                this.messageType = 0;
                this.correlationId = 0;
                this.messageId = 0;
                this.messageFlags = 0;
            }
            return MessageHeader;
        }());
        MessageHeader._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes","name":"MessageHeader","fields":[{"name":"protocol","type":"int"},{"name":"messageType","type":"int"},{"name":"correlationId","type":"long"},{"name":"messageId","type":"long"},{"name":"messageFlags","type":"int"}],"fullName":"Energistics.Datatypes.MessageHeader","depends":[]}');
        Datatypes.MessageHeader = MessageHeader;
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var Protocols;
        (function (Protocols) {
            Protocols[Protocols["Core"] = 0] = "Core";
            Protocols[Protocols["ChannelStreaming"] = 1] = "ChannelStreaming";
            Protocols[Protocols["ChannelDataFrame"] = 2] = "ChannelDataFrame";
            Protocols[Protocols["Discovery"] = 3] = "Discovery";
            Protocols[Protocols["Store"] = 4] = "Store";
            Protocols[Protocols["StoreNotification"] = 5] = "StoreNotification";
            Protocols[Protocols["GrowingObject"] = 6] = "GrowingObject";
            Protocols[Protocols["DataArray"] = 7] = "DataArray";
            Protocols[Protocols["WitsmlSoap"] = 8] = "WitsmlSoap";
        })(Protocols = Datatypes.Protocols || (Datatypes.Protocols = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var Version = (function () {
            function Version() {
                this.major = 0;
                this.minor = 0;
                this.revision = 0;
                this.patch = 0;
            }
            return Version;
        }());
        Version._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes","name":"Version","fields":[{"name":"major","type":"int"},{"name":"minor","type":"int"},{"name":"revision","type":"int"},{"name":"patch","type":"int"}],"fullName":"Energistics.Datatypes.Version","depends":[]}');
        Datatypes.Version = Version;
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var SupportedProtocol = (function () {
            function SupportedProtocol() {
                this.protocol = 0;
                this.protocolVersion = new Energistics.Datatypes.Version();
                this.role = '';
                this.protocolCapabilities = {};
            }
            return SupportedProtocol;
        }());
        SupportedProtocol._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes","name":"SupportedProtocol","fields":[{"name":"protocol","type":"int"},{"name":"protocolVersion","type":"Energistics.Datatypes.Version"},{"name":"role","type":"string"},{"name":"protocolCapabilities","type":{"type":"map","values":"Energistics.Datatypes.DataValue"}}],"fullName":"Energistics.Datatypes.SupportedProtocol","depends":["Energistics.Datatypes.Version","Energistics.Datatypes.DataValue"]}');
        Datatypes.SupportedProtocol = SupportedProtocol;
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ServerCapabilities = (function () {
            function ServerCapabilities() {
                this.applicationName = '';
                this.applicationVersion = '';
                this.supportedProtocols = [];
                this.supportedObjects = [];
                this.contactInformation = new Energistics.Datatypes.Contact();
                this.supportedEncodings = '';
            }
            return ServerCapabilities;
        }());
        ServerCapabilities._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes","name":"ServerCapabilities","fields":[{"name":"applicationName","type":"string"},{"name":"applicationVersion","type":"string"},{"name":"supportedProtocols","type":{"type":"array","items":"Energistics.Datatypes.SupportedProtocol"}},{"name":"supportedObjects","type":{"type":"array","items":"string"}},{"name":"contactInformation","type":"Energistics.Datatypes.Contact"},{"name":"supportedEncodings","type":"string"}],"fullName":"Energistics.Datatypes.ServerCapabilities","depends":["Energistics.Datatypes.SupportedProtocol","Energistics.Datatypes.Contact"]}');
        Datatypes.ServerCapabilities = ServerCapabilities;
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ChannelData;
        (function (ChannelData) {
            var ChannelIndexTypes;
            (function (ChannelIndexTypes) {
                ChannelIndexTypes[ChannelIndexTypes["Time"] = 0] = "Time";
                ChannelIndexTypes[ChannelIndexTypes["Depth"] = 1] = "Depth";
            })(ChannelIndexTypes = ChannelData.ChannelIndexTypes || (ChannelData.ChannelIndexTypes = {}));
        })(ChannelData = Datatypes.ChannelData || (Datatypes.ChannelData = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ChannelData;
        (function (ChannelData) {
            var ChannelStatuses;
            (function (ChannelStatuses) {
                ChannelStatuses[ChannelStatuses["Active"] = 0] = "Active";
                ChannelStatuses[ChannelStatuses["Inactive"] = 1] = "Inactive";
                ChannelStatuses[ChannelStatuses["Closed"] = 2] = "Closed";
            })(ChannelStatuses = ChannelData.ChannelStatuses || (ChannelData.ChannelStatuses = {}));
        })(ChannelData = Datatypes.ChannelData || (Datatypes.ChannelData = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ChannelData;
        (function (ChannelData) {
            var ChannelRangeInfo = (function () {
                function ChannelRangeInfo() {
                    this.channelId = [];
                    this.startIndex = 0;
                    this.endIndex = 0;
                }
                return ChannelRangeInfo;
            }());
            ChannelRangeInfo._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes.ChannelData","name":"ChannelRangeInfo","fields":[{"name":"channelId","type":{"type":"array","items":"long"}},{"name":"startIndex","type":"long"},{"name":"endIndex","type":"long"}],"fullName":"Energistics.Datatypes.ChannelData.ChannelRangeInfo","depends":[]}');
            ChannelData.ChannelRangeInfo = ChannelRangeInfo;
        })(ChannelData = Datatypes.ChannelData || (Datatypes.ChannelData = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ChannelData;
        (function (ChannelData) {
            var DataFrame = (function () {
                function DataFrame() {
                    this.index = [];
                    this.data = [];
                }
                return DataFrame;
            }());
            DataFrame._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes.ChannelData","name":"DataFrame","fields":[{"name":"index","type":{"type":"array","items":"long"}},{"name":"data","type":{"type":"array","items":"Energistics.Datatypes.DataValue"}}],"fullName":"Energistics.Datatypes.ChannelData.DataFrame","depends":["Energistics.Datatypes.DataValue"]}');
            ChannelData.DataFrame = DataFrame;
        })(ChannelData = Datatypes.ChannelData || (Datatypes.ChannelData = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ChannelData;
        (function (ChannelData) {
            var DataItem = (function () {
                function DataItem() {
                    this.indexes = [];
                    this.channelId = 0;
                    this.value = new Energistics.Datatypes.DataValue();
                    this.valueAttributes = [];
                }
                return DataItem;
            }());
            DataItem._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes.ChannelData","name":"DataItem","fields":[{"name":"indexes","type":{"type":"array","items":"long"}},{"name":"channelId","type":"long"},{"name":"value","type":"Energistics.Datatypes.DataValue"},{"name":"valueAttributes","type":{"type":"array","items":"Energistics.Datatypes.DataAttribute"}}],"fullName":"Energistics.Datatypes.ChannelData.DataItem","depends":["Energistics.Datatypes.DataValue","Energistics.Datatypes.DataAttribute"]}');
            ChannelData.DataItem = DataItem;
        })(ChannelData = Datatypes.ChannelData || (Datatypes.ChannelData = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ChannelData;
        (function (ChannelData) {
            var Roles;
            (function (Roles) {
                Roles[Roles["producer"] = 0] = "producer";
                Roles[Roles["consumer"] = 1] = "consumer";
            })(Roles = ChannelData.Roles || (ChannelData.Roles = {}));
        })(ChannelData = Datatypes.ChannelData || (Datatypes.ChannelData = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ChannelData;
        (function (ChannelData) {
            var IndexDirections;
            (function (IndexDirections) {
                IndexDirections[IndexDirections["Increasing"] = 0] = "Increasing";
                IndexDirections[IndexDirections["Decreasing"] = 1] = "Decreasing";
            })(IndexDirections = ChannelData.IndexDirections || (ChannelData.IndexDirections = {}));
        })(ChannelData = Datatypes.ChannelData || (Datatypes.ChannelData = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ChannelData;
        (function (ChannelData) {
            var IndexMetadataRecord = (function () {
                function IndexMetadataRecord() {
                    this.indexType = Energistics.Datatypes.ChannelData.ChannelIndexTypes.Time;
                    this.uom = '';
                    this.direction = Energistics.Datatypes.ChannelData.IndexDirections.Increasing;
                    this.customData = {};
                    this.scale = 0;
                }
                return IndexMetadataRecord;
            }());
            IndexMetadataRecord._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes.ChannelData","name":"IndexMetadataRecord","fields":[{"name":"indexType","type":"Energistics.Datatypes.ChannelData.ChannelIndexTypes"},{"name":"uom","type":"string"},{"name":"depthDatum","type":["null","string"]},{"name":"direction","type":"Energistics.Datatypes.ChannelData.IndexDirections"},{"name":"mnemonic","type":["null","string"]},{"name":"description","type":["null","string"]},{"name":"uri","type":["null","string"]},{"name":"customData","type":{"type":"map","values":"Energistics.Datatypes.DataValue"}},{"name":"scale","type":"int"},{"name":"timeDatum","type":["null","string"]}],"fullName":"Energistics.Datatypes.ChannelData.IndexMetadataRecord","depends":["Energistics.Datatypes.ChannelData.ChannelIndexTypes","Energistics.Datatypes.ChannelData.IndexDirections","Energistics.Datatypes.DataValue"]}');
            ChannelData.IndexMetadataRecord = IndexMetadataRecord;
        })(ChannelData = Datatypes.ChannelData || (Datatypes.ChannelData = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ChannelData;
        (function (ChannelData) {
            var StreamingStartIndex = (function () {
                function StreamingStartIndex() {
                }
                return StreamingStartIndex;
            }());
            StreamingStartIndex._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes.ChannelData","name":"StreamingStartIndex","fields":[{"name":"item","type":["null","int","long"]}],"fullName":"Energistics.Datatypes.ChannelData.StreamingStartIndex","depends":[]}');
            ChannelData.StreamingStartIndex = StreamingStartIndex;
        })(ChannelData = Datatypes.ChannelData || (Datatypes.ChannelData = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ChannelData;
        (function (ChannelData) {
            var ChannelStreamingInfo = (function () {
                function ChannelStreamingInfo() {
                    this.channelId = 0;
                    this.startIndex = new Energistics.Datatypes.ChannelData.StreamingStartIndex();
                    this.receiveChangeNotification = false;
                }
                return ChannelStreamingInfo;
            }());
            ChannelStreamingInfo._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes.ChannelData","name":"ChannelStreamingInfo","fields":[{"name":"channelId","type":"long"},{"name":"startIndex","type":"Energistics.Datatypes.ChannelData.StreamingStartIndex"},{"name":"receiveChangeNotification","type":"boolean"}],"fullName":"Energistics.Datatypes.ChannelData.ChannelStreamingInfo","depends":["Energistics.Datatypes.ChannelData.StreamingStartIndex"]}');
            ChannelData.ChannelStreamingInfo = ChannelStreamingInfo;
        })(ChannelData = Datatypes.ChannelData || (Datatypes.ChannelData = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var Object;
        (function (Object) {
            var GrowingObjectIndex = (function () {
                function GrowingObjectIndex() {
                }
                return GrowingObjectIndex;
            }());
            GrowingObjectIndex._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes.Object","name":"GrowingObjectIndex","fields":[{"name":"item","type":["null","long","double"]}],"fullName":"Energistics.Datatypes.Object.GrowingObjectIndex","depends":[]}');
            Object.GrowingObjectIndex = GrowingObjectIndex;
        })(Object = Datatypes.Object || (Datatypes.Object = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var Object;
        (function (Object) {
            var NotificationRequestRecord = (function () {
                function NotificationRequestRecord() {
                    this.uri = '';
                    this.uuid = '';
                    this.includeObjectData = false;
                    this.startTime = 0;
                    this.objectTypes = [];
                }
                return NotificationRequestRecord;
            }());
            NotificationRequestRecord._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes.Object","name":"NotificationRequestRecord","fields":[{"name":"uri","type":"string"},{"name":"uuid","type":"string"},{"name":"includeObjectData","type":"boolean"},{"name":"startTime","type":"long"},{"name":"objectTypes","type":{"type":"array","items":"string"}}],"fullName":"Energistics.Datatypes.Object.NotificationRequestRecord","depends":[]}');
            Object.NotificationRequestRecord = NotificationRequestRecord;
        })(Object = Datatypes.Object || (Datatypes.Object = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var Object;
        (function (Object) {
            var ObjectChangeTypes;
            (function (ObjectChangeTypes) {
                ObjectChangeTypes[ObjectChangeTypes["Upsert"] = 0] = "Upsert";
                ObjectChangeTypes[ObjectChangeTypes["Delete"] = 1] = "Delete";
            })(ObjectChangeTypes = Object.ObjectChangeTypes || (Object.ObjectChangeTypes = {}));
        })(Object = Datatypes.Object || (Datatypes.Object = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var Object;
        (function (Object) {
            var Resource = (function () {
                function Resource() {
                    this.uri = '';
                    this.contentType = '';
                    this.name = '';
                    this.channelSubscribable = false;
                    this.customData = {};
                    this.resourceType = '';
                    this.hasChildren = 0;
                    this.lastChanged = 0;
                    this.objectNotifiable = false;
                }
                return Resource;
            }());
            Resource._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes.Object","name":"Resource","fields":[{"name":"uri","type":"string"},{"name":"contentType","type":"string"},{"name":"name","type":"string"},{"name":"channelSubscribable","type":"boolean"},{"name":"customData","type":{"type":"map","values":"string"}},{"name":"resourceType","type":"string"},{"name":"hasChildren","type":"int"},{"name":"uuid","type":["null","string"]},{"name":"lastChanged","type":"long"},{"name":"objectNotifiable","type":"boolean"}],"fullName":"Energistics.Datatypes.Object.Resource","depends":[]}');
            Object.Resource = Resource;
        })(Object = Datatypes.Object || (Datatypes.Object = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var Object;
        (function (Object) {
            var DataObject = (function () {
                function DataObject() {
                    this.resource = new Energistics.Datatypes.Object.Resource();
                    this.contentEncoding = '';
                    this.data = '';
                }
                return DataObject;
            }());
            DataObject._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes.Object","name":"DataObject","fields":[{"name":"resource","type":"Energistics.Datatypes.Object.Resource"},{"name":"contentEncoding","type":"string"},{"name":"data","type":"bytes"}],"fullName":"Energistics.Datatypes.Object.DataObject","depends":["Energistics.Datatypes.Object.Resource"]}');
            Object.DataObject = DataObject;
        })(Object = Datatypes.Object || (Datatypes.Object = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var ChannelData;
        (function (ChannelData) {
            var ChannelMetadataRecord = (function () {
                function ChannelMetadataRecord() {
                    this.channelUri = '';
                    this.channelId = 0;
                    this.indexes = [];
                    this.channelName = '';
                    this.dataType = '';
                    this.uom = '';
                    this.description = '';
                    this.status = Energistics.Datatypes.ChannelData.ChannelStatuses.Active;
                    this.source = '';
                    this.measureClass = '';
                    this.customData = {};
                }
                return ChannelMetadataRecord;
            }());
            ChannelMetadataRecord._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes.ChannelData","name":"ChannelMetadataRecord","fields":[{"name":"channelUri","type":"string"},{"name":"channelId","type":"long"},{"name":"indexes","type":{"type":"array","items":"Energistics.Datatypes.ChannelData.IndexMetadataRecord"}},{"name":"channelName","type":"string"},{"name":"dataType","type":"string"},{"name":"uom","type":"string"},{"name":"startIndex","type":["null","long"]},{"name":"endIndex","type":["null","long"]},{"name":"description","type":"string"},{"name":"status","type":"Energistics.Datatypes.ChannelData.ChannelStatuses"},{"name":"contentType","type":["null","string"]},{"name":"source","type":"string"},{"name":"measureClass","type":"string"},{"name":"uuid","type":["null","string"]},{"name":"customData","type":{"type":"map","values":"Energistics.Datatypes.DataValue"}},{"name":"domainObject","type":["null","Energistics.Datatypes.Object.DataObject"]}],"fullName":"Energistics.Datatypes.ChannelData.ChannelMetadataRecord","depends":["Energistics.Datatypes.ChannelData.IndexMetadataRecord","Energistics.Datatypes.ChannelData.ChannelStatuses","Energistics.Datatypes.DataValue","Energistics.Datatypes.Object.DataObject"]}');
            ChannelData.ChannelMetadataRecord = ChannelMetadataRecord;
        })(ChannelData = Datatypes.ChannelData || (Datatypes.ChannelData = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Datatypes;
    (function (Datatypes) {
        var Object;
        (function (Object) {
            var ObjectChange = (function () {
                function ObjectChange() {
                    this.changeType = Energistics.Datatypes.Object.ObjectChangeTypes.Upsert;
                    this.changeTime = 0;
                    this.dataObject = new Energistics.Datatypes.Object.DataObject();
                }
                return ObjectChange;
            }());
            ObjectChange._schema = JSON.parse('{"type":"record","namespace":"Energistics.Datatypes.Object","name":"ObjectChange","fields":[{"name":"changeType","type":"Energistics.Datatypes.Object.ObjectChangeTypes"},{"name":"changeTime","type":"long"},{"name":"dataObject","type":"Energistics.Datatypes.Object.DataObject"}],"fullName":"Energistics.Datatypes.Object.ObjectChange","depends":["Energistics.Datatypes.Object.ObjectChangeTypes","Energistics.Datatypes.Object.DataObject"]}');
            Object.ObjectChange = ObjectChange;
        })(Object = Datatypes.Object || (Datatypes.Object = {}));
    })(Datatypes = Energistics.Datatypes || (Energistics.Datatypes = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var ChannelDataFrame;
        (function (ChannelDataFrame) {
            var ChannelDataFrameSet = (function () {
                function ChannelDataFrameSet() {
                    this.channels = [];
                    this.data = [];
                }
                return ChannelDataFrameSet;
            }());
            ChannelDataFrameSet._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.ChannelDataFrame","name":"ChannelDataFrameSet","messageType":"4","protocol":"2","senderRole":"producer","protocolRoles":"producer,consumer","fields":[{"name":"channels","type":{"type":"array","items":"long"}},{"name":"data","type":{"type":"array","items":"Energistics.Datatypes.ChannelData.DataFrame"}}],"fullName":"Energistics.Protocol.ChannelDataFrame.ChannelDataFrameSet","depends":["Energistics.Datatypes.ChannelData.DataFrame"]}');
            ChannelDataFrameSet._protocol = 2;
            ChannelDataFrameSet._messageTypeId = 4;
            ChannelDataFrame.ChannelDataFrameSet = ChannelDataFrameSet;
            ChannelDataFrame.MsgChannelDataFrameSet = 4;
        })(ChannelDataFrame = Protocol.ChannelDataFrame || (Protocol.ChannelDataFrame = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var ChannelDataFrame;
        (function (ChannelDataFrame) {
            var ChannelMetadata = (function () {
                function ChannelMetadata() {
                    this.channels = [];
                }
                return ChannelMetadata;
            }());
            ChannelMetadata._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.ChannelDataFrame","name":"ChannelMetadata","messageType":"3","protocol":"2","senderRole":"producer","protocolRoles":"producer,consumer","fields":[{"name":"channels","type":{"type":"array","items":"Energistics.Datatypes.ChannelData.ChannelMetadataRecord"}}],"fullName":"Energistics.Protocol.ChannelDataFrame.ChannelMetadata","depends":["Energistics.Datatypes.ChannelData.ChannelMetadataRecord"]}');
            ChannelMetadata._protocol = 2;
            ChannelMetadata._messageTypeId = 3;
            ChannelDataFrame.ChannelMetadata = ChannelMetadata;
            ChannelDataFrame.MsgChannelMetadata = 3;
        })(ChannelDataFrame = Protocol.ChannelDataFrame || (Protocol.ChannelDataFrame = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var ChannelDataFrame;
        (function (ChannelDataFrame) {
            var RequestChannelData = (function () {
                function RequestChannelData() {
                    this.uri = '';
                }
                return RequestChannelData;
            }());
            RequestChannelData._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.ChannelDataFrame","name":"RequestChannelData","messageType":"1","protocol":"2","senderRole":"consumer","protocolRoles":"producer,consumer","fields":[{"name":"uri","type":"string"},{"name":"fromIndex","type":["null","long"]},{"name":"toIndex","type":["null","long"]}],"fullName":"Energistics.Protocol.ChannelDataFrame.RequestChannelData","depends":[]}');
            RequestChannelData._protocol = 2;
            RequestChannelData._messageTypeId = 1;
            ChannelDataFrame.RequestChannelData = RequestChannelData;
            ChannelDataFrame.MsgRequestChannelData = 1;
        })(ChannelDataFrame = Protocol.ChannelDataFrame || (Protocol.ChannelDataFrame = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var ChannelStreaming;
        (function (ChannelStreaming) {
            var ChannelDataChange = (function () {
                function ChannelDataChange() {
                    this.channelId = 0;
                    this.startIndex = 0;
                    this.endIndex = 0;
                    this.data = [];
                }
                return ChannelDataChange;
            }());
            ChannelDataChange._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.ChannelStreaming","name":"ChannelDataChange","messageType":"6","protocol":"1","senderRole":"producer","protocolRoles":"producer,consumer","fields":[{"name":"channelId","type":"long"},{"name":"startIndex","type":"long"},{"name":"endIndex","type":"long"},{"name":"data","type":{"type":"array","items":"Energistics.Datatypes.ChannelData.DataItem"}}],"fullName":"Energistics.Protocol.ChannelStreaming.ChannelDataChange","depends":["Energistics.Datatypes.ChannelData.DataItem"]}');
            ChannelDataChange._protocol = 1;
            ChannelDataChange._messageTypeId = 6;
            ChannelStreaming.ChannelDataChange = ChannelDataChange;
            ChannelStreaming.MsgChannelDataChange = 6;
        })(ChannelStreaming = Protocol.ChannelStreaming || (Protocol.ChannelStreaming = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var ChannelStreaming;
        (function (ChannelStreaming) {
            var ChannelData = (function () {
                function ChannelData() {
                    this.data = [];
                }
                return ChannelData;
            }());
            ChannelData._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.ChannelStreaming","name":"ChannelData","messageType":"3","protocol":"1","senderRole":"producer","protocolRoles":"producer,consumer","fields":[{"name":"data","type":{"type":"array","items":"Energistics.Datatypes.ChannelData.DataItem"}}],"fullName":"Energistics.Protocol.ChannelStreaming.ChannelData","depends":["Energistics.Datatypes.ChannelData.DataItem"]}');
            ChannelData._protocol = 1;
            ChannelData._messageTypeId = 3;
            ChannelStreaming.ChannelData = ChannelData;
            ChannelStreaming.MsgChannelData = 3;
        })(ChannelStreaming = Protocol.ChannelStreaming || (Protocol.ChannelStreaming = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var ChannelStreaming;
        (function (ChannelStreaming) {
            var ChannelDescribe = (function () {
                function ChannelDescribe() {
                    this.uris = [];
                }
                return ChannelDescribe;
            }());
            ChannelDescribe._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.ChannelStreaming","name":"ChannelDescribe","messageType":"1","protocol":"1","senderRole":"consumer","protocolRoles":"producer,consumer","fields":[{"name":"uris","type":{"type":"array","items":"string"}}],"fullName":"Energistics.Protocol.ChannelStreaming.ChannelDescribe","depends":[]}');
            ChannelDescribe._protocol = 1;
            ChannelDescribe._messageTypeId = 1;
            ChannelStreaming.ChannelDescribe = ChannelDescribe;
            ChannelStreaming.MsgChannelDescribe = 1;
        })(ChannelStreaming = Protocol.ChannelStreaming || (Protocol.ChannelStreaming = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var ChannelStreaming;
        (function (ChannelStreaming) {
            var ChannelMetadata = (function () {
                function ChannelMetadata() {
                    this.channels = [];
                }
                return ChannelMetadata;
            }());
            ChannelMetadata._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.ChannelStreaming","name":"ChannelMetadata","messageType":"2","protocol":"1","senderRole":"producer","protocolRoles":"producer,consumer","fields":[{"name":"channels","type":{"type":"array","items":"Energistics.Datatypes.ChannelData.ChannelMetadataRecord"}}],"fullName":"Energistics.Protocol.ChannelStreaming.ChannelMetadata","depends":["Energistics.Datatypes.ChannelData.ChannelMetadataRecord"]}');
            ChannelMetadata._protocol = 1;
            ChannelMetadata._messageTypeId = 2;
            ChannelStreaming.ChannelMetadata = ChannelMetadata;
            ChannelStreaming.MsgChannelMetadata = 2;
        })(ChannelStreaming = Protocol.ChannelStreaming || (Protocol.ChannelStreaming = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var ChannelStreaming;
        (function (ChannelStreaming) {
            var ChannelRangeRequest = (function () {
                function ChannelRangeRequest() {
                    this.channelRanges = [];
                }
                return ChannelRangeRequest;
            }());
            ChannelRangeRequest._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.ChannelStreaming","name":"ChannelRangeRequest","messageType":"9","protocol":"1","senderRole":"consumer","protocolRoles":"producer,consumer","fields":[{"name":"channelRanges","type":{"type":"array","items":"Energistics.Datatypes.ChannelData.ChannelRangeInfo"}}],"fullName":"Energistics.Protocol.ChannelStreaming.ChannelRangeRequest","depends":["Energistics.Datatypes.ChannelData.ChannelRangeInfo"]}');
            ChannelRangeRequest._protocol = 1;
            ChannelRangeRequest._messageTypeId = 9;
            ChannelStreaming.ChannelRangeRequest = ChannelRangeRequest;
            ChannelStreaming.MsgChannelRangeRequest = 9;
        })(ChannelStreaming = Protocol.ChannelStreaming || (Protocol.ChannelStreaming = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var ChannelStreaming;
        (function (ChannelStreaming) {
            var ChannelStreamingStart = (function () {
                function ChannelStreamingStart() {
                    this.channels = [];
                }
                return ChannelStreamingStart;
            }());
            ChannelStreamingStart._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.ChannelStreaming","name":"ChannelStreamingStart","messageType":"4","protocol":"1","senderRole":"consumer","protocolRoles":"producer,consumer","fields":[{"name":"channels","type":{"type":"array","items":"Energistics.Datatypes.ChannelData.ChannelStreamingInfo"}}],"fullName":"Energistics.Protocol.ChannelStreaming.ChannelStreamingStart","depends":["Energistics.Datatypes.ChannelData.ChannelStreamingInfo"]}');
            ChannelStreamingStart._protocol = 1;
            ChannelStreamingStart._messageTypeId = 4;
            ChannelStreaming.ChannelStreamingStart = ChannelStreamingStart;
            ChannelStreaming.MsgChannelStreamingStart = 4;
        })(ChannelStreaming = Protocol.ChannelStreaming || (Protocol.ChannelStreaming = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var ChannelStreaming;
        (function (ChannelStreaming) {
            var ChannelRemove = (function () {
                function ChannelRemove() {
                    this.channelId = 0;
                }
                return ChannelRemove;
            }());
            ChannelRemove._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.ChannelStreaming","name":"ChannelRemove","messageType":"8","protocol":"1","senderRole":"producer","protocolRoles":"producer,consumer","fields":[{"name":"channelId","type":"long"},{"name":"removeReason","type":["null","string"]}],"fullName":"Energistics.Protocol.ChannelStreaming.ChannelRemove","depends":[]}');
            ChannelRemove._protocol = 1;
            ChannelRemove._messageTypeId = 8;
            ChannelStreaming.ChannelRemove = ChannelRemove;
            ChannelStreaming.MsgChannelRemove = 8;
        })(ChannelStreaming = Protocol.ChannelStreaming || (Protocol.ChannelStreaming = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var ChannelStreaming;
        (function (ChannelStreaming) {
            var ChannelStatusChange = (function () {
                function ChannelStatusChange() {
                    this.channelId = 0;
                    this.status = Energistics.Datatypes.ChannelData.ChannelStatuses.Active;
                }
                return ChannelStatusChange;
            }());
            ChannelStatusChange._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.ChannelStreaming","name":"ChannelStatusChange","messageType":"10","protocol":"1","senderRole":"producer","protocolRoles":"producer,consumer","fields":[{"name":"channelId","type":"long"},{"name":"status","type":"Energistics.Datatypes.ChannelData.ChannelStatuses"}],"fullName":"Energistics.Protocol.ChannelStreaming.ChannelStatusChange","depends":["Energistics.Datatypes.ChannelData.ChannelStatuses"]}');
            ChannelStatusChange._protocol = 1;
            ChannelStatusChange._messageTypeId = 10;
            ChannelStreaming.ChannelStatusChange = ChannelStatusChange;
            ChannelStreaming.MsgChannelStatusChange = 10;
        })(ChannelStreaming = Protocol.ChannelStreaming || (Protocol.ChannelStreaming = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var ChannelStreaming;
        (function (ChannelStreaming) {
            var Start = (function () {
                function Start() {
                    this.maxMessageRate = 0;
                    this.maxDataItems = 0;
                }
                return Start;
            }());
            Start._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.ChannelStreaming","name":"Start","messageType":"0","protocol":"1","senderRole":"consumer","protocolRoles":"producer,consumer","fields":[{"name":"maxMessageRate","type":"int"},{"name":"maxDataItems","type":"int"}],"fullName":"Energistics.Protocol.ChannelStreaming.Start","depends":[]}');
            Start._protocol = 1;
            Start._messageTypeId = 0;
            ChannelStreaming.Start = Start;
            ChannelStreaming.MsgStart = 0;
        })(ChannelStreaming = Protocol.ChannelStreaming || (Protocol.ChannelStreaming = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var ChannelStreaming;
        (function (ChannelStreaming) {
            var ChannelStreamingStop = (function () {
                function ChannelStreamingStop() {
                    this.channels = [];
                }
                return ChannelStreamingStop;
            }());
            ChannelStreamingStop._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.ChannelStreaming","name":"ChannelStreamingStop","messageType":"5","protocol":"1","senderRole":"consumer","protocolRoles":"producer,consumer","fields":[{"name":"channels","type":{"type":"array","items":"long"}}],"fullName":"Energistics.Protocol.ChannelStreaming.ChannelStreamingStop","depends":[]}');
            ChannelStreamingStop._protocol = 1;
            ChannelStreamingStop._messageTypeId = 5;
            ChannelStreaming.ChannelStreamingStop = ChannelStreamingStop;
            ChannelStreaming.MsgChannelStreamingStop = 5;
        })(ChannelStreaming = Protocol.ChannelStreaming || (Protocol.ChannelStreaming = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var Core;
        (function (Core) {
            var Acknowledge = (function () {
                function Acknowledge() {
                }
                return Acknowledge;
            }());
            Acknowledge._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.Core","name":"Acknowledge","messageType":"1001","protocol":"0","senderRole":"*","protocolRoles":"client,server","fields":[],"fullName":"Energistics.Protocol.Core.Acknowledge","depends":[]}');
            Acknowledge._protocol = 0;
            Acknowledge._messageTypeId = 1001;
            Core.Acknowledge = Acknowledge;
            Core.MsgAcknowledge = 1001;
        })(Core = Protocol.Core || (Protocol.Core = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var Core;
        (function (Core) {
            var CloseSession = (function () {
                function CloseSession() {
                }
                return CloseSession;
            }());
            CloseSession._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.Core","name":"CloseSession","messageType":"5","protocol":"0","senderRole":"client,server","protocolRoles":"client,server","fields":[{"name":"reason","type":["null","string"]}],"fullName":"Energistics.Protocol.Core.CloseSession","depends":[]}');
            CloseSession._protocol = 0;
            CloseSession._messageTypeId = 5;
            Core.CloseSession = CloseSession;
            Core.MsgCloseSession = 5;
        })(Core = Protocol.Core || (Protocol.Core = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var Core;
        (function (Core) {
            var OpenSession = (function () {
                function OpenSession() {
                    this.applicationName = '';
                    this.applicationVersion = '';
                    this.sessionId = '';
                    this.supportedProtocols = [];
                    this.supportedObjects = [];
                }
                return OpenSession;
            }());
            OpenSession._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.Core","name":"OpenSession","messageType":"2","protocol":"0","senderRole":"server","protocolRoles":"client,server","fields":[{"name":"applicationName","type":"string"},{"name":"applicationVersion","type":"string"},{"name":"sessionId","type":"string"},{"name":"supportedProtocols","type":{"type":"array","items":"Energistics.Datatypes.SupportedProtocol"}},{"name":"supportedObjects","type":{"type":"array","items":"string"}}],"fullName":"Energistics.Protocol.Core.OpenSession","depends":["Energistics.Datatypes.SupportedProtocol"]}');
            OpenSession._protocol = 0;
            OpenSession._messageTypeId = 2;
            Core.OpenSession = OpenSession;
            Core.MsgOpenSession = 2;
        })(Core = Protocol.Core || (Protocol.Core = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var Core;
        (function (Core) {
            var ProtocolException = (function () {
                function ProtocolException() {
                    this.errorCode = 0;
                    this.errorMessage = '';
                }
                return ProtocolException;
            }());
            ProtocolException._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.Core","name":"ProtocolException","messageType":"1000","protocol":"0","senderRole":"*","protocolRoles":"client,server","fields":[{"name":"errorCode","type":"int"},{"name":"errorMessage","type":"string"}],"fullName":"Energistics.Protocol.Core.ProtocolException","depends":[]}');
            ProtocolException._protocol = 0;
            ProtocolException._messageTypeId = 1000;
            Core.ProtocolException = ProtocolException;
            Core.MsgProtocolException = 1000;
        })(Core = Protocol.Core || (Protocol.Core = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var Core;
        (function (Core) {
            var RenewSecurityToken = (function () {
                function RenewSecurityToken() {
                    this.token = '';
                }
                return RenewSecurityToken;
            }());
            RenewSecurityToken._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.Core","name":"RenewSecurityToken","messageType":"6","protocol":"0","senderRole":"client","protocolRoles":"client,server","fields":[{"name":"token","type":"string"}],"fullName":"Energistics.Protocol.Core.RenewSecurityToken","depends":[]}');
            RenewSecurityToken._protocol = 0;
            RenewSecurityToken._messageTypeId = 6;
            Core.RenewSecurityToken = RenewSecurityToken;
            Core.MsgRenewSecurityToken = 6;
        })(Core = Protocol.Core || (Protocol.Core = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var Core;
        (function (Core) {
            var RequestSession = (function () {
                function RequestSession() {
                    this.applicationName = '';
                    this.applicationVersion = '';
                    this.requestedProtocols = [];
                    this.supportedObjects = [];
                }
                return RequestSession;
            }());
            RequestSession._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.Core","name":"RequestSession","messageType":"1","protocol":"0","senderRole":"client","protocolRoles":"client,server","fields":[{"name":"applicationName","type":"string"},{"name":"applicationVersion","type":"string"},{"name":"requestedProtocols","type":{"type":"array","items":"Energistics.Datatypes.SupportedProtocol"}},{"name":"supportedObjects","type":{"type":"array","items":"string"}}],"fullName":"Energistics.Protocol.Core.RequestSession","depends":["Energistics.Datatypes.SupportedProtocol"]}');
            RequestSession._protocol = 0;
            RequestSession._messageTypeId = 1;
            Core.RequestSession = RequestSession;
            Core.MsgRequestSession = 1;
        })(Core = Protocol.Core || (Protocol.Core = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var DataArray;
        (function (DataArray_1) {
            var DataArray = (function () {
                function DataArray() {
                    this.dimensions = [];
                    this.data = new Energistics.Datatypes.AnyArray();
                }
                return DataArray;
            }());
            DataArray._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.DataArray","name":"DataArray","messageType":"1","protocol":"7","senderRole":"store","protocolRoles":"store,customer","fields":[{"name":"dimensions","type":{"type":"array","items":"long"}},{"name":"data","type":"Energistics.Datatypes.AnyArray"}],"fullName":"Energistics.Protocol.DataArray.DataArray","depends":["Energistics.Datatypes.AnyArray"]}');
            DataArray._protocol = 7;
            DataArray._messageTypeId = 1;
            DataArray_1.DataArray = DataArray;
            DataArray_1.MsgDataArray = 1;
        })(DataArray = Protocol.DataArray || (Protocol.DataArray = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var DataArray;
        (function (DataArray) {
            var GetDataArray = (function () {
                function GetDataArray() {
                    this.uri = '';
                }
                return GetDataArray;
            }());
            GetDataArray._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.DataArray","name":"GetDataArray","messageType":"2","protocol":"7","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"uri","type":"string"}],"fullName":"Energistics.Protocol.DataArray.GetDataArray","depends":[]}');
            GetDataArray._protocol = 7;
            GetDataArray._messageTypeId = 2;
            DataArray.GetDataArray = GetDataArray;
            DataArray.MsgGetDataArray = 2;
        })(DataArray = Protocol.DataArray || (Protocol.DataArray = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var DataArray;
        (function (DataArray) {
            var PutDataArraySlice = (function () {
                function PutDataArraySlice() {
                    this.uri = '';
                    this.data = new Energistics.Datatypes.AnyArray();
                    this.dimensions = [];
                    this.start = [];
                    this.count = [];
                }
                return PutDataArraySlice;
            }());
            PutDataArraySlice._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.DataArray","name":"PutDataArraySlice","messageType":"5","protocol":"7","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"uri","type":"string"},{"name":"data","type":"Energistics.Datatypes.AnyArray"},{"name":"dimensions","type":{"type":"array","items":"long"}},{"name":"start","type":{"type":"array","items":"long"}},{"name":"count","type":{"type":"array","items":"long"}}],"fullName":"Energistics.Protocol.DataArray.PutDataArraySlice","depends":["Energistics.Datatypes.AnyArray"]}');
            PutDataArraySlice._protocol = 7;
            PutDataArraySlice._messageTypeId = 5;
            DataArray.PutDataArraySlice = PutDataArraySlice;
            DataArray.MsgPutDataArraySlice = 5;
        })(DataArray = Protocol.DataArray || (Protocol.DataArray = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var DataArray;
        (function (DataArray) {
            var PutDataArray = (function () {
                function PutDataArray() {
                    this.uri = '';
                    this.data = new Energistics.Datatypes.AnyArray();
                    this.dimensions = [];
                }
                return PutDataArray;
            }());
            PutDataArray._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.DataArray","name":"PutDataArray","messageType":"4","protocol":"7","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"uri","type":"string"},{"name":"data","type":"Energistics.Datatypes.AnyArray"},{"name":"dimensions","type":{"type":"array","items":"long"}}],"fullName":"Energistics.Protocol.DataArray.PutDataArray","depends":["Energistics.Datatypes.AnyArray"]}');
            PutDataArray._protocol = 7;
            PutDataArray._messageTypeId = 4;
            DataArray.PutDataArray = PutDataArray;
            DataArray.MsgPutDataArray = 4;
        })(DataArray = Protocol.DataArray || (Protocol.DataArray = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var DataArray;
        (function (DataArray) {
            var GetDataArraySlice = (function () {
                function GetDataArraySlice() {
                    this.uri = '';
                    this.start = [];
                    this.count = [];
                }
                return GetDataArraySlice;
            }());
            GetDataArraySlice._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.DataArray","name":"GetDataArraySlice","messageType":"3","protocol":"7","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"uri","type":"string"},{"name":"start","type":{"type":"array","items":"long"}},{"name":"count","type":{"type":"array","items":"long"}}],"fullName":"Energistics.Protocol.DataArray.GetDataArraySlice","depends":[]}');
            GetDataArraySlice._protocol = 7;
            GetDataArraySlice._messageTypeId = 3;
            DataArray.GetDataArraySlice = GetDataArraySlice;
            DataArray.MsgGetDataArraySlice = 3;
        })(DataArray = Protocol.DataArray || (Protocol.DataArray = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var Discovery;
        (function (Discovery) {
            var GetResourcesResponse = (function () {
                function GetResourcesResponse() {
                    this.resource = new Energistics.Datatypes.Object.Resource();
                }
                return GetResourcesResponse;
            }());
            GetResourcesResponse._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.Discovery","name":"GetResourcesResponse","messageType":"2","protocol":"3","senderRole":"store","protocolRoles":"store,customer","fields":[{"name":"resource","type":"Energistics.Datatypes.Object.Resource"}],"fullName":"Energistics.Protocol.Discovery.GetResourcesResponse","depends":["Energistics.Datatypes.Object.Resource"]}');
            GetResourcesResponse._protocol = 3;
            GetResourcesResponse._messageTypeId = 2;
            Discovery.GetResourcesResponse = GetResourcesResponse;
            Discovery.MsgGetResourcesResponse = 2;
        })(Discovery = Protocol.Discovery || (Protocol.Discovery = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var Discovery;
        (function (Discovery) {
            var GetResources = (function () {
                function GetResources() {
                    this.uri = '';
                }
                return GetResources;
            }());
            GetResources._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.Discovery","name":"GetResources","messageType":"1","protocol":"3","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"uri","type":"string"}],"fullName":"Energistics.Protocol.Discovery.GetResources","depends":[]}');
            GetResources._protocol = 3;
            GetResources._messageTypeId = 1;
            Discovery.GetResources = GetResources;
            Discovery.MsgGetResources = 1;
        })(Discovery = Protocol.Discovery || (Protocol.Discovery = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var GrowingObject;
        (function (GrowingObject) {
            var GrowingObjectDeleteRange = (function () {
                function GrowingObjectDeleteRange() {
                    this.uri = '';
                    this.startIndex = new Energistics.Datatypes.Object.GrowingObjectIndex();
                    this.endIndex = new Energistics.Datatypes.Object.GrowingObjectIndex();
                    this.uom = '';
                    this.depthDatum = '';
                }
                return GrowingObjectDeleteRange;
            }());
            GrowingObjectDeleteRange._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.GrowingObject","name":"GrowingObjectDeleteRange","messageType":"2","protocol":"6","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"uri","type":"string"},{"name":"startIndex","type":"Energistics.Datatypes.Object.GrowingObjectIndex"},{"name":"endIndex","type":"Energistics.Datatypes.Object.GrowingObjectIndex"},{"name":"uom","type":"string"},{"name":"depthDatum","type":"string"}],"fullName":"Energistics.Protocol.GrowingObject.GrowingObjectDeleteRange","depends":["Energistics.Datatypes.Object.GrowingObjectIndex","Energistics.Datatypes.Object.GrowingObjectIndex"]}');
            GrowingObjectDeleteRange._protocol = 6;
            GrowingObjectDeleteRange._messageTypeId = 2;
            GrowingObject.GrowingObjectDeleteRange = GrowingObjectDeleteRange;
            GrowingObject.MsgGrowingObjectDeleteRange = 2;
        })(GrowingObject = Protocol.GrowingObject || (Protocol.GrowingObject = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var GrowingObject;
        (function (GrowingObject) {
            var GrowingObjectDelete = (function () {
                function GrowingObjectDelete() {
                    this.uri = '';
                    this.uid = '';
                }
                return GrowingObjectDelete;
            }());
            GrowingObjectDelete._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.GrowingObject","name":"GrowingObjectDelete","messageType":"1","protocol":"6","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"uri","type":"string"},{"name":"uid","type":"string"}],"fullName":"Energistics.Protocol.GrowingObject.GrowingObjectDelete","depends":[]}');
            GrowingObjectDelete._protocol = 6;
            GrowingObjectDelete._messageTypeId = 1;
            GrowingObject.GrowingObjectDelete = GrowingObjectDelete;
            GrowingObject.MsgGrowingObjectDelete = 1;
        })(GrowingObject = Protocol.GrowingObject || (Protocol.GrowingObject = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var GrowingObject;
        (function (GrowingObject) {
            var GrowingObjectGet = (function () {
                function GrowingObjectGet() {
                    this.uri = '';
                    this.uid = '';
                }
                return GrowingObjectGet;
            }());
            GrowingObjectGet._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.GrowingObject","name":"GrowingObjectGet","messageType":"3","protocol":"6","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"uri","type":"string"},{"name":"uid","type":"string"}],"fullName":"Energistics.Protocol.GrowingObject.GrowingObjectGet","depends":[]}');
            GrowingObjectGet._protocol = 6;
            GrowingObjectGet._messageTypeId = 3;
            GrowingObject.GrowingObjectGet = GrowingObjectGet;
            GrowingObject.MsgGrowingObjectGet = 3;
        })(GrowingObject = Protocol.GrowingObject || (Protocol.GrowingObject = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var GrowingObject;
        (function (GrowingObject) {
            var GrowingObjectGetRange = (function () {
                function GrowingObjectGetRange() {
                    this.uri = '';
                    this.startIndex = new Energistics.Datatypes.Object.GrowingObjectIndex();
                    this.endIndex = new Energistics.Datatypes.Object.GrowingObjectIndex();
                    this.uom = '';
                    this.depthDatum = '';
                }
                return GrowingObjectGetRange;
            }());
            GrowingObjectGetRange._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.GrowingObject","name":"GrowingObjectGetRange","messageType":"4","protocol":"6","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"uri","type":"string"},{"name":"startIndex","type":"Energistics.Datatypes.Object.GrowingObjectIndex"},{"name":"endIndex","type":"Energistics.Datatypes.Object.GrowingObjectIndex"},{"name":"uom","type":"string"},{"name":"depthDatum","type":"string"}],"fullName":"Energistics.Protocol.GrowingObject.GrowingObjectGetRange","depends":["Energistics.Datatypes.Object.GrowingObjectIndex","Energistics.Datatypes.Object.GrowingObjectIndex"]}');
            GrowingObjectGetRange._protocol = 6;
            GrowingObjectGetRange._messageTypeId = 4;
            GrowingObject.GrowingObjectGetRange = GrowingObjectGetRange;
            GrowingObject.MsgGrowingObjectGetRange = 4;
        })(GrowingObject = Protocol.GrowingObject || (Protocol.GrowingObject = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var GrowingObject;
        (function (GrowingObject) {
            var GrowingObjectPut = (function () {
                function GrowingObjectPut() {
                    this.uri = '';
                    this.contentType = '';
                    this.contentEncoding = '';
                    this.data = '';
                }
                return GrowingObjectPut;
            }());
            GrowingObjectPut._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.GrowingObject","name":"GrowingObjectPut","messageType":"5","protocol":"6","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"uri","type":"string"},{"name":"contentType","type":"string"},{"name":"contentEncoding","type":"string"},{"name":"data","type":"bytes"}],"fullName":"Energistics.Protocol.GrowingObject.GrowingObjectPut","depends":[]}');
            GrowingObjectPut._protocol = 6;
            GrowingObjectPut._messageTypeId = 5;
            GrowingObject.GrowingObjectPut = GrowingObjectPut;
            GrowingObject.MsgGrowingObjectPut = 5;
        })(GrowingObject = Protocol.GrowingObject || (Protocol.GrowingObject = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var GrowingObject;
        (function (GrowingObject) {
            var ObjectFragment = (function () {
                function ObjectFragment() {
                    this.uri = '';
                    this.contentType = '';
                    this.contentEncoding = '';
                    this.data = '';
                }
                return ObjectFragment;
            }());
            ObjectFragment._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.GrowingObject","name":"ObjectFragment","messageType":"6","protocol":"6","senderRole":"store","protocolRoles":"store,customer","fields":[{"name":"uri","type":"string"},{"name":"contentType","type":"string"},{"name":"contentEncoding","type":"string"},{"name":"data","type":"bytes"}],"fullName":"Energistics.Protocol.GrowingObject.ObjectFragment","depends":[]}');
            ObjectFragment._protocol = 6;
            ObjectFragment._messageTypeId = 6;
            GrowingObject.ObjectFragment = ObjectFragment;
            GrowingObject.MsgObjectFragment = 6;
        })(GrowingObject = Protocol.GrowingObject || (Protocol.GrowingObject = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var Store;
        (function (Store) {
            var DeleteObject = (function () {
                function DeleteObject() {
                    this.uri = '';
                }
                return DeleteObject;
            }());
            DeleteObject._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.Store","name":"DeleteObject","messageType":"3","protocol":"4","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"uri","type":"string"}],"fullName":"Energistics.Protocol.Store.DeleteObject","depends":[]}');
            DeleteObject._protocol = 4;
            DeleteObject._messageTypeId = 3;
            Store.DeleteObject = DeleteObject;
            Store.MsgDeleteObject = 3;
        })(Store = Protocol.Store || (Protocol.Store = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var Store;
        (function (Store) {
            var GetObject = (function () {
                function GetObject() {
                    this.uri = '';
                }
                return GetObject;
            }());
            GetObject._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.Store","name":"GetObject","messageType":"1","protocol":"4","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"uri","type":"string"}],"fullName":"Energistics.Protocol.Store.GetObject","depends":[]}');
            GetObject._protocol = 4;
            GetObject._messageTypeId = 1;
            Store.GetObject = GetObject;
            Store.MsgGetObject = 1;
        })(Store = Protocol.Store || (Protocol.Store = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var Store;
        (function (Store) {
            var PutObject = (function () {
                function PutObject() {
                    this.dataObject = new Energistics.Datatypes.Object.DataObject();
                }
                return PutObject;
            }());
            PutObject._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.Store","name":"PutObject","messageType":"2","protocol":"4","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"dataObject","type":"Energistics.Datatypes.Object.DataObject"}],"fullName":"Energistics.Protocol.Store.PutObject","depends":["Energistics.Datatypes.Object.DataObject"]}');
            PutObject._protocol = 4;
            PutObject._messageTypeId = 2;
            Store.PutObject = PutObject;
            Store.MsgPutObject = 2;
        })(Store = Protocol.Store || (Protocol.Store = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var Store;
        (function (Store) {
            var Object = (function () {
                function Object() {
                    this.dataObject = new Energistics.Datatypes.Object.DataObject();
                }
                return Object;
            }());
            Object._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.Store","name":"Object","messageType":"4","protocol":"4","senderRole":"store","protocolRoles":"store,customer","fields":[{"name":"dataObject","type":"Energistics.Datatypes.Object.DataObject"}],"fullName":"Energistics.Protocol.Store.Object","depends":["Energistics.Datatypes.Object.DataObject"]}');
            Object._protocol = 4;
            Object._messageTypeId = 4;
            Store.Object = Object;
            Store.MsgObject = 4;
        })(Store = Protocol.Store || (Protocol.Store = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var StoreNotification;
        (function (StoreNotification) {
            var ChangeNotification = (function () {
                function ChangeNotification() {
                    this.change = new Energistics.Datatypes.Object.ObjectChange();
                }
                return ChangeNotification;
            }());
            ChangeNotification._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.StoreNotification","name":"ChangeNotification","messageType":"2","protocol":"5","senderRole":"store","protocolRoles":"store,customer","fields":[{"name":"change","type":"Energistics.Datatypes.Object.ObjectChange"}],"fullName":"Energistics.Protocol.StoreNotification.ChangeNotification","depends":["Energistics.Datatypes.Object.ObjectChange"]}');
            ChangeNotification._protocol = 5;
            ChangeNotification._messageTypeId = 2;
            StoreNotification.ChangeNotification = ChangeNotification;
            StoreNotification.MsgChangeNotification = 2;
        })(StoreNotification = Protocol.StoreNotification || (Protocol.StoreNotification = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var StoreNotification;
        (function (StoreNotification) {
            var DeleteNotification = (function () {
                function DeleteNotification() {
                    this.delete = new Energistics.Datatypes.Object.ObjectChange();
                }
                return DeleteNotification;
            }());
            DeleteNotification._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.StoreNotification","name":"DeleteNotification","messageType":"3","protocol":"5","senderRole":"store","protocolRoles":"store,customer","fields":[{"name":"delete","type":"Energistics.Datatypes.Object.ObjectChange"}],"fullName":"Energistics.Protocol.StoreNotification.DeleteNotification","depends":["Energistics.Datatypes.Object.ObjectChange"]}');
            DeleteNotification._protocol = 5;
            DeleteNotification._messageTypeId = 3;
            StoreNotification.DeleteNotification = DeleteNotification;
            StoreNotification.MsgDeleteNotification = 3;
        })(StoreNotification = Protocol.StoreNotification || (Protocol.StoreNotification = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var StoreNotification;
        (function (StoreNotification) {
            var CancelNotification = (function () {
                function CancelNotification() {
                    this.requestUuid = '';
                }
                return CancelNotification;
            }());
            CancelNotification._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.StoreNotification","name":"CancelNotification","messageType":"4","protocol":"5","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"requestUuid","type":"string"}],"fullName":"Energistics.Protocol.StoreNotification.CancelNotification","depends":[]}');
            CancelNotification._protocol = 5;
            CancelNotification._messageTypeId = 4;
            StoreNotification.CancelNotification = CancelNotification;
            StoreNotification.MsgCancelNotification = 4;
        })(StoreNotification = Protocol.StoreNotification || (Protocol.StoreNotification = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var StoreNotification;
        (function (StoreNotification) {
            var NotificationRequest = (function () {
                function NotificationRequest() {
                    this.request = new Energistics.Datatypes.Object.NotificationRequestRecord();
                }
                return NotificationRequest;
            }());
            NotificationRequest._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.StoreNotification","name":"NotificationRequest","messageType":"1","protocol":"5","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"request","type":"Energistics.Datatypes.Object.NotificationRequestRecord"}],"fullName":"Energistics.Protocol.StoreNotification.NotificationRequest","depends":["Energistics.Datatypes.Object.NotificationRequestRecord"]}');
            NotificationRequest._protocol = 5;
            NotificationRequest._messageTypeId = 1;
            StoreNotification.NotificationRequest = NotificationRequest;
            StoreNotification.MsgNotificationRequest = 1;
        })(StoreNotification = Protocol.StoreNotification || (Protocol.StoreNotification = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var WitsmlSoap;
        (function (WitsmlSoap) {
            var WMLS_AddToStore = (function () {
                function WMLS_AddToStore() {
                    this.WMLtypeIn = '';
                    this.XMLin = '';
                    this.OptionsIn = '';
                    this.CapabilitiesIn = '';
                }
                return WMLS_AddToStore;
            }());
            WMLS_AddToStore._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.WitsmlSoap","name":"WMLS_AddToStore","messageType":"1","protocol":"8","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"WMLtypeIn","type":"string"},{"name":"XMLin","type":"string"},{"name":"OptionsIn","type":"string"},{"name":"CapabilitiesIn","type":"string"}],"fullName":"Energistics.Protocol.WitsmlSoap.WMLS_AddToStore","depends":[]}');
            WMLS_AddToStore._protocol = 8;
            WMLS_AddToStore._messageTypeId = 1;
            WitsmlSoap.WMLS_AddToStore = WMLS_AddToStore;
            WitsmlSoap.MsgWMLS_AddToStore = 1;
        })(WitsmlSoap = Protocol.WitsmlSoap || (Protocol.WitsmlSoap = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var WitsmlSoap;
        (function (WitsmlSoap) {
            var WMLS_DeleteFromStore = (function () {
                function WMLS_DeleteFromStore() {
                    this.WMLtypeIn = '';
                    this.XMLin = '';
                    this.OptionsIn = '';
                    this.CapabilitiesIn = '';
                }
                return WMLS_DeleteFromStore;
            }());
            WMLS_DeleteFromStore._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.WitsmlSoap","name":"WMLS_DeleteFromStore","messageType":"3","protocol":"8","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"WMLtypeIn","type":"string"},{"name":"XMLin","type":"string"},{"name":"OptionsIn","type":"string"},{"name":"CapabilitiesIn","type":"string"}],"fullName":"Energistics.Protocol.WitsmlSoap.WMLS_DeleteFromStore","depends":[]}');
            WMLS_DeleteFromStore._protocol = 8;
            WMLS_DeleteFromStore._messageTypeId = 3;
            WitsmlSoap.WMLS_DeleteFromStore = WMLS_DeleteFromStore;
            WitsmlSoap.MsgWMLS_DeleteFromStore = 3;
        })(WitsmlSoap = Protocol.WitsmlSoap || (Protocol.WitsmlSoap = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var WitsmlSoap;
        (function (WitsmlSoap) {
            var WMLS_GetBaseMsg = (function () {
                function WMLS_GetBaseMsg() {
                    this.ReturnValueIn = 0;
                }
                return WMLS_GetBaseMsg;
            }());
            WMLS_GetBaseMsg._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.WitsmlSoap","name":"WMLS_GetBaseMsg","messageType":"5","protocol":"8","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"ReturnValueIn","type":"int"}],"fullName":"Energistics.Protocol.WitsmlSoap.WMLS_GetBaseMsg","depends":[]}');
            WMLS_GetBaseMsg._protocol = 8;
            WMLS_GetBaseMsg._messageTypeId = 5;
            WitsmlSoap.WMLS_GetBaseMsg = WMLS_GetBaseMsg;
            WitsmlSoap.MsgWMLS_GetBaseMsg = 5;
        })(WitsmlSoap = Protocol.WitsmlSoap || (Protocol.WitsmlSoap = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var WitsmlSoap;
        (function (WitsmlSoap) {
            var WMLS_GetCap = (function () {
                function WMLS_GetCap() {
                    this.OptionsIn = '';
                }
                return WMLS_GetCap;
            }());
            WMLS_GetCap._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.WitsmlSoap","name":"WMLS_GetCap","messageType":"7","protocol":"8","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"OptionsIn","type":"string"}],"fullName":"Energistics.Protocol.WitsmlSoap.WMLS_GetCap","depends":[]}');
            WMLS_GetCap._protocol = 8;
            WMLS_GetCap._messageTypeId = 7;
            WitsmlSoap.WMLS_GetCap = WMLS_GetCap;
            WitsmlSoap.MsgWMLS_GetCap = 7;
        })(WitsmlSoap = Protocol.WitsmlSoap || (Protocol.WitsmlSoap = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var WitsmlSoap;
        (function (WitsmlSoap) {
            var WMLS_GetVersion = (function () {
                function WMLS_GetVersion() {
                }
                return WMLS_GetVersion;
            }());
            WMLS_GetVersion._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.WitsmlSoap","name":"WMLS_GetVersion","messageType":"11","protocol":"8","senderRole":"customer","protocolRoles":"store,customer","fields":[],"fullName":"Energistics.Protocol.WitsmlSoap.WMLS_GetVersion","depends":[]}');
            WMLS_GetVersion._protocol = 8;
            WMLS_GetVersion._messageTypeId = 11;
            WitsmlSoap.WMLS_GetVersion = WMLS_GetVersion;
            WitsmlSoap.MsgWMLS_GetVersion = 11;
        })(WitsmlSoap = Protocol.WitsmlSoap || (Protocol.WitsmlSoap = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var WitsmlSoap;
        (function (WitsmlSoap) {
            var WMLS_GetFromStore = (function () {
                function WMLS_GetFromStore() {
                    this.WMLtypeIn = '';
                    this.XMLin = '';
                    this.OptionsIn = '';
                    this.CapabilitiesIn = '';
                }
                return WMLS_GetFromStore;
            }());
            WMLS_GetFromStore._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.WitsmlSoap","name":"WMLS_GetFromStore","messageType":"9","protocol":"8","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"WMLtypeIn","type":"string"},{"name":"XMLin","type":"string"},{"name":"OptionsIn","type":"string"},{"name":"CapabilitiesIn","type":"string"}],"fullName":"Energistics.Protocol.WitsmlSoap.WMLS_GetFromStore","depends":[]}');
            WMLS_GetFromStore._protocol = 8;
            WMLS_GetFromStore._messageTypeId = 9;
            WitsmlSoap.WMLS_GetFromStore = WMLS_GetFromStore;
            WitsmlSoap.MsgWMLS_GetFromStore = 9;
        })(WitsmlSoap = Protocol.WitsmlSoap || (Protocol.WitsmlSoap = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var WitsmlSoap;
        (function (WitsmlSoap) {
            var WMLS_UpdateInStore = (function () {
                function WMLS_UpdateInStore() {
                    this.WMLtypeIn = '';
                    this.XMLin = '';
                    this.OptionsIn = '';
                    this.CapabilitiesIn = '';
                }
                return WMLS_UpdateInStore;
            }());
            WMLS_UpdateInStore._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.WitsmlSoap","name":"WMLS_UpdateInStore","messageType":"13","protocol":"8","senderRole":"customer","protocolRoles":"store,customer","fields":[{"name":"WMLtypeIn","type":"string"},{"name":"XMLin","type":"string"},{"name":"OptionsIn","type":"string"},{"name":"CapabilitiesIn","type":"string"}],"fullName":"Energistics.Protocol.WitsmlSoap.WMLS_UpdateInStore","depends":[]}');
            WMLS_UpdateInStore._protocol = 8;
            WMLS_UpdateInStore._messageTypeId = 13;
            WitsmlSoap.WMLS_UpdateInStore = WMLS_UpdateInStore;
            WitsmlSoap.MsgWMLS_UpdateInStore = 13;
        })(WitsmlSoap = Protocol.WitsmlSoap || (Protocol.WitsmlSoap = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var WitsmlSoap;
        (function (WitsmlSoap) {
            var WMSL_AddToStoreResponse = (function () {
                function WMSL_AddToStoreResponse() {
                    this.Result = 0;
                    this.SuppMsgOut = '';
                }
                return WMSL_AddToStoreResponse;
            }());
            WMSL_AddToStoreResponse._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.WitsmlSoap","name":"WMSL_AddToStoreResponse","messageType":"2","protocol":"8","senderRole":"store","protocolRoles":"store,customer","fields":[{"name":"Result","type":"int"},{"name":"SuppMsgOut","type":"string"}],"fullName":"Energistics.Protocol.WitsmlSoap.WMSL_AddToStoreResponse","depends":[]}');
            WMSL_AddToStoreResponse._protocol = 8;
            WMSL_AddToStoreResponse._messageTypeId = 2;
            WitsmlSoap.WMSL_AddToStoreResponse = WMSL_AddToStoreResponse;
            WitsmlSoap.MsgWMSL_AddToStoreResponse = 2;
        })(WitsmlSoap = Protocol.WitsmlSoap || (Protocol.WitsmlSoap = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var WitsmlSoap;
        (function (WitsmlSoap) {
            var WMSL_GetCapResponse = (function () {
                function WMSL_GetCapResponse() {
                    this.Result = 0;
                    this.CapabilitiesOut = '';
                    this.SuppMsgOut = '';
                }
                return WMSL_GetCapResponse;
            }());
            WMSL_GetCapResponse._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.WitsmlSoap","name":"WMSL_GetCapResponse","messageType":"8","protocol":"8","senderRole":"store","protocolRoles":"store,customer","fields":[{"name":"Result","type":"int"},{"name":"CapabilitiesOut","type":"string"},{"name":"SuppMsgOut","type":"string"}],"fullName":"Energistics.Protocol.WitsmlSoap.WMSL_GetCapResponse","depends":[]}');
            WMSL_GetCapResponse._protocol = 8;
            WMSL_GetCapResponse._messageTypeId = 8;
            WitsmlSoap.WMSL_GetCapResponse = WMSL_GetCapResponse;
            WitsmlSoap.MsgWMSL_GetCapResponse = 8;
        })(WitsmlSoap = Protocol.WitsmlSoap || (Protocol.WitsmlSoap = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var WitsmlSoap;
        (function (WitsmlSoap) {
            var WMSL_DeleteFromStoreResponse = (function () {
                function WMSL_DeleteFromStoreResponse() {
                    this.Result = 0;
                    this.SuppMsgOut = '';
                }
                return WMSL_DeleteFromStoreResponse;
            }());
            WMSL_DeleteFromStoreResponse._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.WitsmlSoap","name":"WMSL_DeleteFromStoreResponse","messageType":"4","protocol":"8","senderRole":"store","protocolRoles":"store,customer","fields":[{"name":"Result","type":"int"},{"name":"SuppMsgOut","type":"string"}],"fullName":"Energistics.Protocol.WitsmlSoap.WMSL_DeleteFromStoreResponse","depends":[]}');
            WMSL_DeleteFromStoreResponse._protocol = 8;
            WMSL_DeleteFromStoreResponse._messageTypeId = 4;
            WitsmlSoap.WMSL_DeleteFromStoreResponse = WMSL_DeleteFromStoreResponse;
            WitsmlSoap.MsgWMSL_DeleteFromStoreResponse = 4;
        })(WitsmlSoap = Protocol.WitsmlSoap || (Protocol.WitsmlSoap = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var WitsmlSoap;
        (function (WitsmlSoap) {
            var WMSL_GetBaseMsgResponse = (function () {
                function WMSL_GetBaseMsgResponse() {
                    this.Result = '';
                }
                return WMSL_GetBaseMsgResponse;
            }());
            WMSL_GetBaseMsgResponse._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.WitsmlSoap","name":"WMSL_GetBaseMsgResponse","messageType":"6","protocol":"8","senderRole":"store","protocolRoles":"store,customer","fields":[{"name":"Result","type":"string"}],"fullName":"Energistics.Protocol.WitsmlSoap.WMSL_GetBaseMsgResponse","depends":[]}');
            WMSL_GetBaseMsgResponse._protocol = 8;
            WMSL_GetBaseMsgResponse._messageTypeId = 6;
            WitsmlSoap.WMSL_GetBaseMsgResponse = WMSL_GetBaseMsgResponse;
            WitsmlSoap.MsgWMSL_GetBaseMsgResponse = 6;
        })(WitsmlSoap = Protocol.WitsmlSoap || (Protocol.WitsmlSoap = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var WitsmlSoap;
        (function (WitsmlSoap) {
            var WMSL_GetFromStoreResponse = (function () {
                function WMSL_GetFromStoreResponse() {
                    this.Result = 0;
                    this.XMLout = '';
                    this.SuppMsgOut = '';
                }
                return WMSL_GetFromStoreResponse;
            }());
            WMSL_GetFromStoreResponse._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.WitsmlSoap","name":"WMSL_GetFromStoreResponse","messageType":"10","protocol":"8","senderRole":"store","protocolRoles":"store,customer","fields":[{"name":"Result","type":"int"},{"name":"XMLout","type":"string"},{"name":"SuppMsgOut","type":"string"}],"fullName":"Energistics.Protocol.WitsmlSoap.WMSL_GetFromStoreResponse","depends":[]}');
            WMSL_GetFromStoreResponse._protocol = 8;
            WMSL_GetFromStoreResponse._messageTypeId = 10;
            WitsmlSoap.WMSL_GetFromStoreResponse = WMSL_GetFromStoreResponse;
            WitsmlSoap.MsgWMSL_GetFromStoreResponse = 10;
        })(WitsmlSoap = Protocol.WitsmlSoap || (Protocol.WitsmlSoap = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var WitsmlSoap;
        (function (WitsmlSoap) {
            var WMSL_GetVersionResponse = (function () {
                function WMSL_GetVersionResponse() {
                    this.Result = '';
                }
                return WMSL_GetVersionResponse;
            }());
            WMSL_GetVersionResponse._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.WitsmlSoap","name":"WMSL_GetVersionResponse","messageType":"12","protocol":"8","senderRole":"store","protocolRoles":"store,customer","fields":[{"name":"Result","type":"string"}],"fullName":"Energistics.Protocol.WitsmlSoap.WMSL_GetVersionResponse","depends":[]}');
            WMSL_GetVersionResponse._protocol = 8;
            WMSL_GetVersionResponse._messageTypeId = 12;
            WitsmlSoap.WMSL_GetVersionResponse = WMSL_GetVersionResponse;
            WitsmlSoap.MsgWMSL_GetVersionResponse = 12;
        })(WitsmlSoap = Protocol.WitsmlSoap || (Protocol.WitsmlSoap = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
(function (Energistics) {
    var Protocol;
    (function (Protocol) {
        var WitsmlSoap;
        (function (WitsmlSoap) {
            var WMSL_UpdateInStoreResponse = (function () {
                function WMSL_UpdateInStoreResponse() {
                    this.Result = 0;
                    this.SuppMsgOut = '';
                }
                return WMSL_UpdateInStoreResponse;
            }());
            WMSL_UpdateInStoreResponse._schema = JSON.parse('{"type":"record","namespace":"Energistics.Protocol.WitsmlSoap","name":"WMSL_UpdateInStoreResponse","messageType":"14","protocol":"8","senderRole":"store","protocolRoles":"store,customer","fields":[{"name":"Result","type":"int"},{"name":"SuppMsgOut","type":"string"}],"fullName":"Energistics.Protocol.WitsmlSoap.WMSL_UpdateInStoreResponse","depends":[]}');
            WMSL_UpdateInStoreResponse._protocol = 8;
            WMSL_UpdateInStoreResponse._messageTypeId = 14;
            WitsmlSoap.WMSL_UpdateInStoreResponse = WMSL_UpdateInStoreResponse;
            WitsmlSoap.MsgWMSL_UpdateInStoreResponse = 14;
        })(WitsmlSoap = Protocol.WitsmlSoap || (Protocol.WitsmlSoap = {}));
    })(Protocol = Energistics.Protocol || (Energistics.Protocol = {}));
})(Energistics = exports.Energistics || (exports.Energistics = {}));
//# sourceMappingURL=EtpMessages.js.map